export default "__VITE_ASSET__xl0eWcrO__"